var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFineArtsPalette(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{fill:#FFFFFF;stroke:#000000;stroke-width:15;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#000000;stroke-width:15;stroke-miterlimit:10;}\r\n\t.st4{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000085250769749564394010000013966411904037341572_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M540,61.6L281.2,584l128.7,168.3c15.7,20.5,24.2,45.7,24.2,71.5v193.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M540,61.6L798.8,584L670.1,752.3c-15.7,20.5-24.2,45.7-24.2,71.5v193.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 540,
    y1: 24,
    x2: 540,
    y2: 593.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 581.6,
    r: 42.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 365.9,
    y1: 899.2,
    x2: 711.8,
    y2: 899.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 495.3,
    y: 899.2,
    width: 150.6,
    height: 117.6
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M512.1,951c-110.2-20-222.3-78.8-299.7-157.2c-85.5-86.5-122.7-188.6-104.8-287.4 c9.8-54.2,30-103.4,59.8-146.1c28.3-40.4,64.7-74.4,108.3-100.9c85.3-51.8,192.7-71.6,302.3-55.9c6,0.9,12.2,1.9,18.4,3 C686,222.9,794.5,266,879.5,319.2c95.2,59.6,150,123,154.2,178.4c2.1,27.5-8.6,53.1-31.6,76.2c-26.2,26.3-68.4,49.5-125.6,69 c-49.5,16.9-77.1,39.3-81.9,66.4c-7.1,39.6,36,74.9,52.2,88.1c1.7,1.4,3.7,3,4.2,3.5c30.2,31.7,39.3,66.2,24.8,94.8 c-13.6,26.9-47.2,47.1-97.2,58.3c-60.5,13.6-142.1,13.9-242.5,0.8C528.2,953.7,520.1,952.4,512.1,951z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595,214.2c88.7,16.1,196.2,58.8,280.4,111.6c44,27.5,80.8,57.3,106.4,86c27.3,30.6,42.1,59.6,44.1,86.4 c1.9,25.5-7.7,48.4-29.4,70.1c-25.3,25.4-66.6,48-122.6,67.2c-53.1,18.2-81.5,41.8-87,72.3c-7.9,44.1,37.7,81.4,54.9,95.5 c1.4,1.1,3,2.5,3.6,3c27.7,29.1,36.3,60.4,23.4,85.8c-12.6,24.8-44.4,43.6-92,54.3c-59.6,13.4-140.3,13.6-239.8,0.6 c-7.8-1-15.8-2.3-23.7-3.7c-53.4-9.7-108.5-28.9-159.4-55.4c-51.3-26.8-98.4-61.2-136.3-99.6c-40.2-40.6-69.6-84.7-87.5-130.9 c-19.2-49.5-24.3-99.8-15.2-149.8c9.6-53.1,29.3-101.3,58.5-143c27.7-39.6,63.3-72.8,106-98.7c83.8-50.9,189.3-70.3,297.2-54.8 C582.8,212.1,588.9,213.1,595,214.2L595,214.2 M597.8,199c-6.3-1.1-12.6-2.2-18.7-3c-222.4-32-437.7,80.7-479.1,309 C60,725.2,288,918.2,510.7,958.6c8.2,1.5,16.3,2.8,24.5,3.8c350.4,45.8,403.2-81.2,321.4-166.8c-8-8.4-132.8-92.2,22.5-145.4 C1273.7,515.1,858.8,246.3,597.8,199L597.8,199z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.2,
    cy: 552.8,
    rx: 71.8,
    ry: 71.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M268.9,482.9c38.5,7,64.2,44,57.2,82.6c-7,38.5-44,64.2-82.6,57.2c-38.5-7-64.2-44-57.2-82.6 C193.3,501.5,230.4,475.9,268.9,482.9 M269.2,481.3c-39.4-7.2-77.2,19-84.4,58.5s19,77.2,58.5,84.4s77.2-19,84.4-58.5 C334.8,526.3,308.6,488.5,269.2,481.3L269.2,481.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 345.5,
    cy: 371,
    rx: 71.8,
    ry: 71.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M358.2,301.1c38.5,7,64.2,44,57.2,82.6c-7,38.5-44,64.2-82.6,57.2c-38.5-7-64.2-44-57.2-82.6 C282.6,319.8,319.6,294.1,358.2,301.1 M358.4,299.6c-39.4-7.2-77.2,19-84.4,58.5c-7.2,39.4,19,77.2,58.5,84.4s77.2-19,84.4-58.5 C424.1,344.5,397.9,306.7,358.4,299.6L358.4,299.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M538.1,389.6c-38.9-7.1-64.9-44.5-57.8-83.5c7.1-38.9,44.5-64.9,83.5-57.8c38.9,7.1,64.9,44.5,57.8,83.5 C614.5,370.7,577.1,396.7,538.1,389.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M563.6,249.1c38.5,7,64.2,44,57.2,82.6s-44,64.2-82.6,57.2c-38.5-7-64.2-44-57.2-82.6 C488.1,267.7,525.1,242.1,563.6,249.1 M563.9,247.5c-39.4-7.2-77.2,19-84.4,58.5c-7.2,39.4,19,77.2,58.5,84.4s77.2-19,84.4-58.5 S603.3,254.7,563.9,247.5L563.9,247.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M744.3,462.1c-38.9-7.1-64.9-44.5-57.8-83.5c7.1-38.9,44.5-64.9,83.5-57.8c38.9,7.1,64.9,44.5,57.8,83.5 C820.7,443.2,783.3,469.2,744.3,462.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M769.8,321.6c38.5,7,64.2,44,57.2,82.6s-44,64.2-82.6,57.2c-38.5-7-64.2-44-57.2-82.6 C694.2,340.2,731.3,314.6,769.8,321.6 M770.1,320c-39.4-7.2-77.2,19-84.4,58.5s19,77.2,58.5,84.4c39.4,7.2,77.2-19,84.4-58.5 S809.5,327.2,770.1,320L770.1,320z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    className: "st0"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "688.4,939.2 284.3,939.2 465.4,561.4  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 703.9,
    cy: 398.1,
    r: 163.4
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFineArtsPalette);
export default __webpack_public_path__ + "static/media/Fine-Arts-Palette.339b4d56edc392c60082c37b50cfeff5.svg";
export { ForwardRef as ReactComponent };